import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import Backend from 'i18next-xhr-backend';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { languages } from './languages';
import { get } from '../../api/requester';
import { toAbsoluteUrl } from '../../_metronic/_helpers';

// const availableLanguages = languages.map(lang => lang.lang);
export let availableLanguages = languages;
let isInitialized = false;

export const fetchLanguages = async () => {
  try {
    const results = await get('/api/localization/cultures');
    return [
      ...languages,
      ...results.map((res) => ({
        id: res.id,
        lang: res.code,
        name: res.name,
        nameLocal: res.nameLocal,
        flag: toAbsoluteUrl(`/media/svg/flags/${res.code}.svg`),
      })),
    ];
  } catch (e) {
    console.error('fetchLanguages failed', e);
    return languages; // fallback to local
  }
};

const loadResource = async (locale) => {
    return await get('/api/localization/resources', { CultureCode: locale })
}

const backendOpts = {
    // loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
    loadPath: '{{lng}}|{{ns}}',
    request: (options, url, payload, callback) => {
        try {
            const [lng, type] = url.split('|');
            loadResource(lng).then((data) => {
                callback(null, {
                    data,
                    status: 200
                })
            }).catch((res) => {
                if (res.Status === 404 || res.Status === 500) {
                    //fallback to local en file
                    fetch(`${process.env.PUBLIC_URL}/locales/en/translation.json`, {
                        headers : { 
                          'Content-Type': 'application/json',
                          'Accept': 'application/json'
                         }
                    }).then((response) => {
                        return response.json();
                    }).then((data) => {
                        callback(null, {
                            data,
                            status: 200
                        })
                    });
                } else {
                    console.log("Translations for this language does not exist on the BE")
                    callback(null, {status: res.Status});
                }
            })
        } catch (e) {
            callback(null, {status: 500});
        }
    }
}

const setLanguages = (res) => {
    availableLanguages = [ ...res ];
    const langs = [ ...res ].map(lang => lang.lang);

    if (!isInitialized) {
        i18n
            // load translation using xhr -> see /public/locales
            // learn more: https://github.com/i18next/i18next-xhr-backend
            // default folder is public/locales/{{lng}}/{{ns}}.json
            .use(Backend)
            // detect user language
            // learn more: https://github.com/i18next/i18next-browser-languageDetector
            .use(LanguageDetector)
            // pass the i18n instance to react-i18next.
            .use(initReactI18next)
            // init i18next
            // for all options read: https://www.i18next.com/overview/configuration-options
            .init({
                fallbackLng: 'en',
                debug: process.env.NODE_ENV === 'development' ? true : false,
                whitelist: langs,
                //keySeparator: false,
                interpolation: {
                    escapeValue: false, // not needed for react as it escapes by default
                },
                backend: backendOpts,
                //resources: {
                //  'en': {
                //    'translation': en_lang // 'translation' is our custom namespace
                //  },
                //},
                // react i18next special options (optional)
                react: {
                    bindI18n: 'loaded languageChanged',
                    bindI18nStore: 'added',
                    useSuspense: true,
                }
            });
    } else {
        // just update languages and reload translations if needed
        i18n.options.whitelist = langs;
        i18n.reloadResources();
    }

}

setLanguages(languages);

export const reloadLanguages = async () => {
  const res = await fetchLanguages();
  setLanguages(res);
};

export default i18n;
